import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'
import React from 'react'

const TextValue = ({ title, value, loading, classNameValue = '' }) => {
  return (
    <div>
      <Typography color="primary" variant='subtitle1' className='text-center capitalize'>{title}</Typography>
      <Typography variant='body2' className={`text-center flex items-center justify-center ${classNameValue}`}>
        { loading ? <Skeleton width={100} /> : value }
      </Typography>
    </div>
  )
}

export default TextValue